import React, { useState, useEffect, useCallback } from "react";
import axiosConfig from '../../../src/axiosConfig';
import Swal from "sweetalert2";
import CancelIcon from '@material-ui/icons/Cancel';
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import styles from "../../shared/dashboardStyle";

const useStyles = makeStyles(styles);

export default function SensitiveData(props) {
  const [sensitiveInfo, setSensitiveInfo] = useState(
    {
      firstname: '',
      lastname: '',
      addressStreet: '',
      phone: '',
      mobile: '',
      personOfContact: '',
      postalCode: '',
      area: '',
      municipality: ''
    });
  const age = props.alertAge;
  const genderId = props.alertGender === 1 ? 'Άντρας' : 'Γυναίκα';
  const beneficiaryId = props.beneficiaryId;
  const userId = props.userId;
  const open = props.open;

  const classes = useStyles();
  const values = {
    id: beneficiaryId,
    verifiedUserId: userId
  }
  const handleClose = () => {
    props.close();
  };
  const getSensitiveData = useCallback(() => {
    axiosConfig.post(`/Beneficiary/SensitiveData`, values).then((res) => {
      const sensitiveData = res.data;
      setSensitiveInfo({
        firstname: sensitiveData.firstname,
        lastname: sensitiveData.lastname,
        addressStreet: sensitiveData.addressStreet,
        mobile: sensitiveData.mobile,
        phone: sensitiveData.phone,
        personOfContact: sensitiveData.personOfContact,
        area: sensitiveData.area,
        municipality: sensitiveData.municipality,
        postalCode: sensitiveData.postalCode
      })
    }).catch(() => Swal.fire('Δεν βρέθηκαν Προσωπικά στοιχεία'))
  }, [beneficiaryId, userId])

  useEffect(() => {
    getSensitiveData()
  }, [])
  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <DialogContent className={classes.dialogContent}>
        <DialogContentText>
          <Grid container>
            <Grid item xs={12} sm={10}>
              Προσωπικά Στοιχεία Ωφελούμενου
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button onClick={handleClose}>
                <CancelIcon />
              </Button>
            </Grid>
          </Grid>
        </DialogContentText>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              disabled
              id="lastname"
              name="lastname"
              label="Επώνυμο"
              fullWidth
              value={sensitiveInfo.lastname}
              autoComplete="family-name"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              disabled
              id="firstname"
              name="firstname"
              label="Όνομα"
              fullWidth
              value={sensitiveInfo.firstname}
              autoComplete="given-name"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              disabled
              id="age"
              name="age"
              label="Ηλικία"
              fullWidth
              value={age}
              autoComplete="given-name"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              disabled
              id="genderId"
              name="genderId"
              label="Φύλο"
              fullWidth
              value={genderId}
              autoComplete="given-name"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              disabled
              id="addressStreet"
              name="addressStreet"
              label="Διεύθυνση"
              fullWidth
              value={sensitiveInfo.addressStreet}
              autoComplete="shipping address-line1"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              disabled
              id="postalCode"
              name="postalCode"
              label="ΤΚ"
              fullWidth
              value={sensitiveInfo.postalCode}
              autoComplete="shipping address-line1"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              disabled
              id="municipality"
              name="municipality"
              label="Δήμος"
              fullWidth
              value={sensitiveInfo.municipality}
              autoComplete="shipping address-line1"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              disabled
              id="area"
              name="area"
              label="Περιοχή"
              fullWidth
              value={sensitiveInfo.area}
              autoComplete="shipping address-line1"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              disabled
              id="phone"
              name="phone"
              label="Τηλέφωνο"
              fullWidth
              value={sensitiveInfo.phone}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              disabled
              id="mobile"
              name="mobile"
              label="Τηλέφωνο 2"
              fullWidth
              value={sensitiveInfo.mobile}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              disabled
              id="personOfContact"
              name="personOfContact"
              label="Πρόσωπο Επικοινωνίας"
              fullWidth
              value={sensitiveInfo.personOfContact}
              variant="outlined"
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )

}


